import * as React from 'react';
import Ship from './assets/portShip.jpg';
import { Brands } from './Brands';
import { Footer } from './Footer';
import { Points } from './Points';

export const Marketing: React.FC = () => {
  return (
    <div
      className="bg-cover bg-right h-full text-white p-20 pb-8 space-y-8 flex flex-col"
      style={{
        backgroundImage: `linear-gradient(60.17deg, rgba(37, 41, 64, 0.85) 32.35%, rgba(37, 41, 64, 0.8) 100%), url(${Ship})`,
      }}
    >
      <div className="space-y-1">
        <h1 className="text-blue-100 font-bold text-xlg">
          All your port terminal data in one platform
        </h1>
        <h2 className="text-orange-400 font-medium">14-day Free Trial for New Companies!</h2>
      </div>
      <div className="space-y-3">
        <h2>Trusted by thousands of companies</h2>
        <Brands />
      </div>
      <div className="py-2" />
      <Points />
      <div className="grow" />
      <Footer />
    </div>
  );
};
